import React from "react";
import ReactDOM from "react-dom";
import HistoryCarousel from "./containers/HistoryCarousel";
import { getElementsProperty } from "../helpers/getElementsProperty";

export const initHistoryCarousels = className => {
  getElementsProperty(className, (property, element) => {
    ReactDOM.render(<HistoryCarousel items={property.items} />, element);
  });
};
